import { setTimeout, $contentArea } from 'utils/wrappers';

export function flash(message, klass) {
  const contentArea = $contentArea();
  let flashContainer = contentArea.find('.flash-container');

  if (flashContainer.length === 0) {
    contentArea.prepend("<div class='flash-container'></div>");
    flashContainer = contentArea.find('.flash-container');
  }

  const html = `${'' +
    '<div class="alert '}${klass}">` +
    '<button class="button close" data-dismiss="alert">×</button>' +
    `<div class="content text-center">${message}</div>` +
    '</div>';

  flashContainer.html(html);

  setTimeout(() => {
    flashContainer.fadeOut(400, () => {
      flashContainer.remove();
    });
  }, 8000);
}

export function showError(message) {
  flash(message, 'alert-danger');
}

export function showResponseError(response) {
  const message = JSON.parse(response.responseText).error.message;
  showError(message);
}

export function showSuccess(message) {
  flash(message, 'alert-success');
}

export function hideFlash() {
  $contentArea().find('.flash-container').html('');
}

export function isFlashShown(klass) {
  const alertDiv = $contentArea().find('.flash-container .alert');

  if (alertDiv.length === 0) return false;

  if (klass && !alertDiv.hasClass(klass)) return false;

  return true;
}



// WEBPACK FOOTER //
// ./utils/messages.js